module.exports = __webpack_public_path__ + "img/NukedTV-Web_32.3b2f24be.png";